// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-home-home-approach----home-approach-module---wrapper---wdvap","container":"src-components-home-home-approach----home-approach-module---container---2yrhL","message":"src-components-home-home-approach----home-approach-module---message---3KvVo","title":"src-components-home-home-approach----home-approach-module---title---1ZVhu","content":"src-components-home-home-approach----home-approach-module---content---1_fup","description":"src-components-home-home-approach----home-approach-module---description---V7LnN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home-approach/home-approach.module.css
// module id = 488
// module chunks = 35783957827783